module.exports = __webpack_public_path__ + "static/og-image-968a3eaba129d9ba50c4e5d8dde7d81e.png";